export const onMpinRequired = (navLink: string) => {
  // Status 424 is for 2FA journey
  if (
    typeof window === 'object' &&
    !window.location.pathname.includes('journey/2fa') &&
    navLink
  ) {
    const url = new URL(navLink)
    const search = new URLSearchParams(url.search)
    const currUrl = new URL(window.location.href)
    search.append(
      'return_to',
      encodeURIComponent(currUrl.pathname + currUrl.search).substring(0, 1000),
    )
    window.location.href = `${url.pathname}?${search.toString()}`
  }
}
